import {LatLngTuple} from 'leaflet'

export const swipeCoords = (coords: LatLngTuple[]) => {
    return coords?.map((coord: LatLngTuple) => [coord[1], coord[0]]);
  };